var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleTrashIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "14.5465mm",
    height: "14.547mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 91.2 91.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_982529714480"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "svgActiveBorder",
    cx: 45.6,
    cy: 45.6,
    r: 45.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "svgActiveBg",
    cx: 45.6,
    cy: 45.6,
    rx: 38.87,
    ry: 38.88
  })), /*#__PURE__*/React.createElement("path", {
    className: "svgActiveText",
    d: "M31.77 62.69c0.13,2.05 1.83,3.64 3.88,3.64l19.9 0c2.05,0 3.75,-1.6 3.88,-3.64l1.72 -27.45 -31.09 0 1.72 27.45zm13.83 -20.98l0 0c0.55,0 1.01,0.45 1.01,1.01l0 15.59c0,0.55 -0.45,1.01 -1.01,1.01l0 0c-0.55,0 -1.01,-0.45 -1.01,-1.01l0 -15.59c0,-0.55 0.45,-1.01 1.01,-1.01zm-7.61 0l0 0c0.55,0 1.03,0.45 1.05,1.01l0.76 15.59c0.03,0.55 -0.4,1.01 -0.96,1.01l0 0c-0.55,0 -1.03,-0.45 -1.05,-1.01l-0.76 -15.59c-0.03,-0.55 0.4,-1.01 0.96,-1.01zm15.21 0c0.55,0 0.98,0.45 0.96,1.01l-0.76 15.59c-0.03,0.55 -0.5,1.01 -1.05,1.01l0 0c-0.55,0 -0.98,-0.45 -0.96,-1.01l0.76 -15.59c0.03,-0.55 0.5,-1.01 1.05,-1.01l0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgActiveText",
    d: "M62.44 27.46l-9.72 0 -0.76 -1.51c-0.33,-0.66 -1,-1.08 -1.74,-1.08 0,0 -0,0 -0,0l-9.26 0c-0,0 -0.01,0 -0.01,0 -0.73,0 -1.4,0.42 -1.73,1.08l-0.76 1.51 -9.72 0c-0.72,0 -1.3,0.58 -1.3,1.3l0 2.59c0,0.72 0.58,1.3 1.3,1.3l33.68 0c0.72,0 1.3,-0.58 1.3,-1.3l0 -2.59c0,-0.72 -0.58,-1.3 -1.3,-1.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleTrashIconActive);
export default __webpack_public_path__ + "static/media/circleTrashIconActive.0ae2bbd3.svg";
export { ForwardRef as ReactComponent };